/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PatchExperimentPathParams = NonNullable<operations['patchExperiment']['parameters']['path']>;

export type PatchExperimentRequestBody = OperationRequestBodyContent<operations['patchExperiment']>;

export interface Input extends PatchExperimentPathParams {
  apiVersion?: string;
  body: PatchExperimentRequestBody;
}

export async function patchExperiment(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PATCH('/api/v2/projects/{projectKey}/environments/{environmentKey}/experiments/{experimentKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
